import {
    Button,
    Card,
    CircularProgress,
    Grid,
    Icon,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core';
import { AddRounded, FilterListRounded, MoreHoriz } from '@material-ui/icons';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { ValidatorForm } from 'react-material-ui-form-validator';
import ScrollBar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { MatxMenu } from '../../../matx';
import { BackdropLoading, TablePagination } from '../../components';
import { delKota, getKota } from '../../redux/actions/KotaActions';
import { getProvinsi } from '../../redux/actions/ProvinsiActions';

const Kota = ({ location }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [page, setPage] = useState('0');
    const [show, setShow] = useState('25');
    const [search, setSearch] = useState('');
    const [prov, setProv] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const { provinsi } = useSelector(
        ({ provinsi }) => provinsi
    );
    const { kota, loadingKota, kotaPagination, totalKota } = useSelector(
        ({ kota }) => kota
    );

    const getData = useCallback((limit, hal, cari, provinsi) => {
        dispatch(getKota({limit, hal, cari, provinsi}));
    }, [dispatch]);

    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        });
    };

    const handleDelete = (code, nama) => {
        Swal.fire({
            title: 'Konfirmasi Hapus',
            text: 'Apakah anda yakin ingin menghapus data ' + nama,
            imageUrl: `/assets/images/icons/ic_delete.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Hapus',
            confirmButtonColor: '#FD6D5D',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            cancelButtonColor: '#0083E2',
            reverseButtons: true
        }).then((res) => {
            if (res.isConfirmed) {
                sendDelete(code);
            }
        });
    };

    const sendDelete = (code) => {
        setShowLoading(true);
        delKota(code)
            .then(() => {
                getData(show, page, search, prov);
                setShowLoading(false);
                showAlert('Berhasil menghapus data', true);
            })
            .catch((err) => {
                let error = err?.response?.data;
                setShowLoading(false);
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menghapus data, coba beberapa saat lagi',
                    false
                );
            });
    };

    useEffect(() => {
        let params = new URLSearchParams(location?.search);
        let limit = params.get('limit') || '25';
        let cari = params.get('cari') || '';
        let hal = params.get('hal') ? params.get('hal') : '1';
        let provinsi = params.get('prov') || '';
        setShow(limit);
        setPage(hal);
        setSearch(cari);
        setProv(provinsi);
        getData(limit, hal, cari, provinsi);
    }, [location.search, getData]);

    useEffect(() => {
        dispatch(getProvinsi({paginate: false}))
    }, [dispatch]);

    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={10} className="flex items-center">
                    <h3 className="fw-bold m-0">Kota</h3>
                </Grid>
                <Grid item xs={5} md={2}>
                    <Link
                        to="/kota/tambah"
                        className="btn btn-primary border-radius-0 text-white font-14 w-full"
                    >
                        <AddRounded /> Tambah
                    </Link>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card className="w-full pt-6 pb-4 border-radius-0" elevation={0}>
                        <Grid
                            container
                            spacing={2}
                            justifyContent="flex-end"
                            className="mb-2 px-4"
                        >
                            <Grid item xs={12} md={4}>
                                <form
                                    noValidate
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        history.push(
                                            `/kota?hal=${page}&limit=${show}&cari=${search}&prov=${prov}`
                                        );
                                    }}
                                >
                                    <TextField
                                        value={search}
                                        placeholder="Cari kota"
                                        variant="outlined"
                                        onChange={({ target: { value } }) =>
                                            setSearch(value)
                                        }
                                        size="small"
                                        className="w-full"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        size="small"
                                                        type="submit"
                                                    >
                                                        <Icon
                                                            size="small"
                                                            color="action"
                                                        >
                                                            search
                                                        </Icon>
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </form>
                            </Grid>
                            <Grid item xs={5} md={2}>
                                <MatxMenu
                                    menuButton={
                                        <Button className="border px-6 w-full">
                                            Filter{' '}
                                            <FilterListRounded className="ms-2" />
                                        </Button>
                                    }
                                    horizontalPosition="right"
                                    classBtn="w-full text-right"
                                    shouldCloseOnItemClick={false}
                                >
                                    <div
                                        className="px-7 py-4"
                                        style={{ maxWidth: 500 }}
                                    >
                                        <h5 className="mb-6 fw-bold">
                                            Filter Kota
                                        </h5>
                                        <ValidatorForm
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                history.push(
                                                    `/kota?hal=${page}&limit=${show}&cari=${search}&prov=${prov}`
                                                );
                                            }}
                                            className="w-full"
                                        >
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Select
                                                        SelectDisplayProps={{
                                                            style: {
                                                                paddingTop: 10,
                                                                paddingBottom: 10
                                                            }
                                                        }}
                                                        size="small"
                                                        labelId="role"
                                                        value={prov}
                                                        onChange={({
                                                            target: { value }
                                                        }) => setProv(value)}
                                                        variant="outlined"
                                                        className="w-full"
                                                        name="role"
                                                        displayEmpty
                                                    >
                                                        <MenuItem
                                                            value=""
                                                            selected
                                                        >
                                                            Provinsi
                                                        </MenuItem>
                                                        {provinsi?.map(
                                                            (item) => (
                                                                <MenuItem
                                                                    value={
                                                                        item.province_code
                                                                    }
                                                                    key={
                                                                        item.province_code
                                                                    }
                                                                >
                                                                    {
                                                                        item.province_name
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                        className="w-full text-white"
                                                        disableElevation
                                                    >
                                                        Filter
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </ValidatorForm>
                                    </div>
                                </MatxMenu>
                            </Grid>
                        </Grid>
                        <ScrollBar className="flex-grow flex-column relative h-full">
                            <Table className={clsx('whitespace-pre min-w-750')}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            className="w-90 border-b"
                                        >
                                            No
                                        </TableCell>
                                        <TableCell className='border-b'>Kota</TableCell>
                                        <TableCell className='border-b'>Provinsi</TableCell>
                                        <TableCell className='w-90 border-b' align="center">
                                            Aksi
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {loadingKota ? (
                                        <TableRow hover>
                                            <TableCell
                                                className="px-0"
                                                align="center"
                                                colSpan={4}
                                            >
                                                <CircularProgress
                                                    size={25}
                                                    color="primary"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ) : kota?.length <= 0 ? (
                                        <TableRow hover>
                                            <TableCell
                                                className="px-0"
                                                align="center"
                                                colSpan={4}
                                            >
                                                Data kosong.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        kota?.map((item, i) => (
                                            <TableRow
                                                hover
                                                key={item.city_code}
                                            >
                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                >
                                                    {show * (page - 1) +
                                                        (i + 1)}
                                                </TableCell>
                                                <TableCell className="px-0">
                                                    {item.city_name}
                                                </TableCell>
                                                <TableCell className="px-0">
                                                    {item.province_name}
                                                </TableCell>
                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                >
                                                    <MatxMenu
                                                        menuButton={
                                                            <div className="flex items-center">
                                                                <IconButton size="small">
                                                                    <MoreHoriz />
                                                                </IconButton>
                                                            </div>
                                                        }
                                                        horizontalPosition="right"
                                                    >
                                                        <MenuItem>
                                                            <Link
                                                                to={`/kota/edit/${item.city_code}`}
                                                                className="popup-menu-item"
                                                            >
                                                                <img
                                                                    src="/assets/images/icons/ic_action_edit.svg"
                                                                    alt="icon edit"
                                                                />
                                                                <span className="pl-4">
                                                                    {' '}
                                                                    Edit{' '}
                                                                </span>
                                                            </Link>
                                                        </MenuItem>
                                                        <MenuItem>
                                                            <Link
                                                                to={
                                                                    '/kota' +
                                                                    location?.search
                                                                }
                                                                onClick={() =>
                                                                    handleDelete(
                                                                        item.city_code,
                                                                        item.city_name
                                                                    )
                                                                }
                                                                className="popup-menu-item"
                                                            >
                                                                <img
                                                                    src="/assets/images/icons/ic_action_delete.svg"
                                                                    alt="icon hapus"
                                                                />
                                                                <span className="pl-4">
                                                                    {' '}
                                                                    Hapus{' '}
                                                                </span>
                                                            </Link>
                                                        </MenuItem>
                                                    </MatxMenu>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </ScrollBar>
                        <Grid container spacing={2} className="mt-2 px-5">
                            <Grid item xs={12} className="flex justify-center justify-content-lg-between items-center">
                                {
                                    loadingKota ?
                                        <p className='text-muted m-0 d-none d-lg-block'>Mengambil Data...</p>
                                    :
                                        <p className='text-muted m-0 d-none d-lg-block'>Menampilkan {parseInt(show) * (parseInt(page) - 1) + 1} sampai {parseInt(page) * parseInt(show)} dari {totalKota} data</p>
                                }
                                <div className="d-flex justify-content-end container-pagination mt-4 flex-column flex-md-row items-center">
                                    <div className="d-flex align-items-center mb-3">
                                        <p className="m-0 mr-2">Tampilkan</p>
                                        <Form.Select
                                            aria-label="Tampilkan"
                                            className="font-14 border-radius-0"
                                            value={show}
                                            onChange={({ target: { value } }) =>
                                                history.push(
                                                    `/kota?hal=${page}&limit=${value}&cari=${search}&prov=${prov}`
                                                )
                                            }
                                        >
                                            <option value="100">100</option>
                                            <option value="25">25</option>
                                            <option value="10">10</option>
                                            <option value="5">5</option>
                                        </Form.Select>
                                    </div>
                                    <TablePagination
                                        href="/kota"
                                        page={page}
                                        params={`&limit=${show}&cari=${search}&prov=${prov}`}
                                        total={kotaPagination}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
            <BackdropLoading open={showLoading} />
        </div>
    );
};

export default Kota;
